import { defineComponent, ref, watch, computed } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "../../locales/index.mjs";
import Dialog from "../common/base/Dialog/index.mjs";
import TuiButton from "../common/base/Button.vue.mjs";
import SuccessIcon from "../common/icons/SuccessIcon.vue.mjs";
import copyIcon from "../common/icons/CopyIcon.vue.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import useRoomInfo from "../RoomHeader/RoomInfo/useRoomInfoHooks.mjs";
import { getUrlWithRoomId } from "../../utils/utils.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ShareLink",
  props: {
    conferenceInfo: null,
    scheduleParams: null,
    visible: { type: Boolean }
  },
  emits: ["input", "close"],
  setup(__props, { emit }) {
    const props = __props;
    const basicStore = useBasicStore();
    const { isRoomLinkVisible } = storeToRefs(basicStore);
    const roomLinkConfig = roomService.getComponentConfig("RoomLink");
    const { t } = useI18n();
    const { onCopy } = useRoomInfo();
    const showRoomInvite = ref(false);
    watch(
      () => props.visible,
      (val) => {
        showRoomInvite.value = val;
      },
      {
        immediate: true
      }
    );
    const updateVisible = (val) => {
      emit("input", val);
    };
    const roomType = computed(
      () => props.scheduleParams.isSeatEnabled ? `${t("On-stage Speaking Room")}` : `${t("Free Speech Room")}`
    );
    const isShowPassword = computed(() => !!props.scheduleParams.password);
    function copyRoomIdAndRoomLink() {
      const invitationList = [
        `${props.scheduleParams.roomName}`,
        `${t("Room Type")}: ${roomType.value}`,
        `${t("Room ID")}: ${props.scheduleParams.roomId}`
      ];
      if (isShowPassword.value) {
        invitationList.push(
          `${t("Room Password")}: ${props.scheduleParams.password}`
        );
      }
      if (isRoomLinkVisible.value && roomLinkConfig.visible) {
        invitationList.push(
          `${t("Room Link")}: ${getUrlWithRoomId(props.scheduleParams.roomId)}`
        );
      }
      const invitation = invitationList.join("\n");
      onCopy(invitation);
    }
    const scheduleInviteList = computed(() => [
      {
        id: 1,
        title: `${t("Invitation by room ID")}`,
        content: props.scheduleParams.roomId
      },
      {
        id: 2,
        title: `${t("Invitation via room link")}`,
        content: getUrlWithRoomId(props.scheduleParams.roomId)
      }
    ]);
    watch(
      showRoomInvite,
      (val) => {
        updateVisible(val);
      },
      { immediate: true }
    );
    return { __sfc: true, basicStore, isRoomLinkVisible, roomLinkConfig, t, onCopy, props, emit, showRoomInvite, updateVisible, roomType, isShowPassword, copyRoomIdAndRoomLink, scheduleInviteList, TuiDialog: Dialog, TuiButton, SuccessIcon, copyIcon, SvgIcon };
  }
});
export {
  _sfc_main as default
};
